import { render, staticRenderFns } from "./WorkflowSettings.vue?vue&type=template&id=1533f3aa&scoped=true"
import script from "./WorkflowSettings.vue?vue&type=script&lang=ts"
export * from "./WorkflowSettings.vue?vue&type=script&lang=ts"
import style0 from "./WorkflowSettings.vue?vue&type=style&index=0&id=1533f3aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1533f3aa",
  null
  
)

export default component.exports